"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _async = _interopRequireDefault(require("react-select/async"));
var _DropdownIndicator = require("../../../SearchableReactSelect/components/DropdownIndicator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MemberSearchableBan = function MemberSearchableBan(_ref) {
  var _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? _lodash.noop : _ref$onSelect,
    _ref$onLoadOptions = _ref.onLoadOptions,
    onLoadOptions = _ref$onLoadOptions === void 0 ? _lodash.noop : _ref$onLoadOptions;
  return /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search member name...",
    onChange: onSelect,
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    loadOptions: onLoadOptions,
    isClearable: true
  });
};
var _default = MemberSearchableBan;
exports.default = _default;